import ResistanceLandingComponent from 'components/marketingSite/resistanceLanding/ResistanceLandingComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type ResistanceLandingPageProps = WithBaseUrl;

const ResistanceLandingPage: React.FC<ResistanceLandingPageProps> = ({
  baseUrl
}) => {
  const { t } = useI18n('resistanceLanding');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('page_title')}
        desc={t('page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_resistance.png'
        )}`}
      />
      <ResistanceLandingComponent />
    </>
  );
};

export default ResistanceLandingPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'resistanceLanding'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
